<div class="upsell-product-box p-4">
  <div class="upsell-product-box__container max-w-container justify-center mx-auto w-full">

    @if (productBoxTitle) {
      <div class="upsell-product-box__title text-3xl text-center bg-lw-green text-white font-bold p-4 desktop:py-8 desktop:px-12 text-balance" [innerHTML]="productBoxTitle"></div>
    }
    <div class="upsell-product-box__wrapper">

      <div class="upsell-product-box__content flex flex-col items-stretch desktop:flex-row">

        <div class="upsell-product-box__image-wrapper bg-[#FFEBDB] basis-1/2 p-4 desktop:py-12 desktop:px-10 flex flex-col justify-center items-center desktop:flex-shrink-0">
          <img class="upsell-product-box__image self-center" [src]="image" alt="{{ imageAlt }}">
        </div>

        <div class="upsell-product-box__description flex items-center bg-lw-tan basis-1/2 p-4 desktop:py-12 desktop:px-10">
          <div class="mx-auto">
            @if (productBoxSubtitle) {
              <p class="upsell-product-box__subtitle text-2xl mb-2.5 font-medium" [innerHTML]="productBoxSubtitle"></p>
            }

            <div class="upsell-product-box__pricing">
              <div class="mb-2.5"><div class="h-px bg-lw-green"></div></div>
              <p class="upsell-product-box__regularPrice text-xl font-bold mb-2">
                <span class="upsell-product-box__regularPrice-text">{{regularText}}: </span>
                <span class="upsell-product-box__regularPrice-number">{{ regularPrice | dynamicCurrency:currency }}</span>
              </p>

              <p class="upsell-product-box__instantSavings text-2xl font-bold text-lw-orange">
                <span class="upsell-product-box__instantSavings-text">{{instantSavingsText}}: </span>
                <span class="upsell-product-box__instantSavings-number">{{ instantSavings | dynamicCurrency:currency }}</span>
              </p>
              <div class="mt-2.5"><div class="h-px bg-lw-green"></div></div>

              <p class="upsell-product-box__yourPrice pt-2.5 text-3xl font-extrabold">
                <span class="upsell-product-box__yourPrice-text">{{yourPriceText}}: </span>
                <span class="upsell-product-box__yourPrice-number">{{ yourPrice | dynamicCurrency:currency }} {{ currency !== 'USD' ? currency : '' }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (productBoxCTA) {
      <upsell-buttons [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" (eventEmitter)="nextPage($event)"></upsell-buttons>
    }
  </div>
</div>
